import React, { Fragment } from 'react';
import classnames from 'classnames';
import PopupButton from './PopupButton';
import Icon from 'assets/icons';
import { removeSpecialCharacters } from 'helpers/string';

import styles from './PlusButton.module.scss';

const button = (
  <Fragment>
    <Icon.PlusCircle className={styles.icon} />
  </Fragment>
);

interface PlusButtonProps {
  activeClassName?: any;
  className?: any;
  id?: any;
  onClosePopup?: any;
  onMouseEnter?: any;
  onOpenPopup?: any;
  posX?: any;
  posY?: any;
  size?: any;
  type?: any;
  content: React.ReactNode;
}

export const PlusButton: React.FC<PlusButtonProps> = ({
  activeClassName,
  className,
  id,
  onClosePopup,
  onMouseEnter,
  onOpenPopup,
  posX = 'left',
  posY = 'even',
  size,
  type,
  content,
}) => (
  <PopupButton
    buttonActiveClass={classnames(activeClassName, styles.active)}
    buttonClassName={classnames(className, styles.button, {
      [styles[`size-${size}`]]: size,
      [styles[`type-${type}`]]: type,
    })}
    buttonProps={{ type: 'Plain' }}
    className={classnames(styles.shareWindowWrapper)}
    id={removeSpecialCharacters(id)}
    label={button}
    onClose={onClosePopup}
    onOpen={onOpenPopup}
    onMouseEnter={onMouseEnter}
    popupClassName={classnames(styles.shareWindow, {
      [styles[`posX--${posX}`]]: posX,
      [styles[`posY--${posY}`]]: posY,
    })}
  >
    {content}
  </PopupButton>
);
